module.exports = __webpack_public_path__ + "img/total_ticket_white.efbbc3a6.png";